import React, { useContext } from 'react'
import View from '../../atoms/View'
import Text from '../../atoms/TextNew'
import ExpandedViewProperty from '../../atoms/ExpandedViewProperty'
import { t } from 'i18next'
import { formatPrice } from 'src/helpers/formatPrice'
import ActionBar from './ActionBar'
import { ItemContext, ItemDispatchContext } from 'src/contexts/itemContext'
import Button from 'src/components/atoms/Button'

const LikeItemExpanded = ({ expandedView }: { expandedView: boolean }): JSX.Element => {
  const itemContext = useContext(ItemContext)
  const dispatchItemContext = useContext(ItemDispatchContext)

  if (itemContext === null || dispatchItemContext === null) {
    throw new Error('itemContext must be used within a ItemProvider')
  }
  const {
    year,
    total_mileage,
    region,
    id,
    vehicle_type,
    bets_count,
    current_dealer_highest_bet,
    buy_now_contract,
    highest_bet,
    bar
  } = itemContext
  const yourBetExists = current_dealer_highest_bet !== null && current_dealer_highest_bet > 0
  const buyNowPrice = buy_now_contract?.price ?? 0
  const yourBetIsHighest = current_dealer_highest_bet === highest_bet

  const getBetColor = (): 'lightGrey' | 'groupBlue' | 'errorRed' => {
    if (!yourBetExists) return 'lightGrey'
    return yourBetIsHighest ? 'groupBlue' : 'errorRed'
  }

  return (
    <View
      style={{
        height: expandedView ? 260 : 0,
        overflow: 'hidden',
        transition: 'height 500ms ease'
      }}>
      <View
        className="grid grid-cols-4 gap-10 pl-8 pt-8 pb-2 cursor-default"
        onClick={(e) => {
          e.stopPropagation()
        }}>
        <View>
          <ExpandedViewProperty
            label={t(vehicle_type === 'AgriculturalMachine' ? 'agricultural_production_year' : 'date')}
            value={year}
          />
          <ExpandedViewProperty label={t('mileage')} value={total_mileage} />
          <ExpandedViewProperty label={t('country')} value={region} />
          <ExpandedViewProperty label={t('bets_count')} value={bets_count} />
        </View>
        <View>
          <ExpandedViewProperty
            color={getBetColor()}
            label={t('your_offer')}
            value={yourBetExists ? `€ ${formatPrice(current_dealer_highest_bet)}` : '-'}
          />
          <ExpandedViewProperty
            label={t('buy_now_expanded_view')}
            value={buyNowPrice > 0 ? `€ ${formatPrice(buyNowPrice)}` : '-'}
          />
          <ExpandedViewProperty
            label={t('highest_offer')}
            value={highest_bet > 0 ? `€ ${formatPrice(highest_bet)}` : '-'}
          />
        </View>
        <View className="flex justify-center"></View>
        <View className="flex justify-center items-start">
          {buyNowPrice > 0 && bar !== 'thank_you_buy_now' && bar !== 'auction_contract' && (
            <Button
              color="motoOrange"
              customStyles="w-[150px]"
              onClick={() => {
                dispatchItemContext({ type: 'SET_BAR', payload: 'auction_contract' })
              }}>
              <Text className="text-center text-l cursor-pointer text-white font-Bold">
                <>{t('single_offer.place_an_different_offer')}</>
              </Text>
            </Button>
          )}
        </View>
      </View>
      <ActionBar
        buyNowPrice={buyNowPrice}
        highestBet={highest_bet}
        offerId={id}
        currentDealerHighestBet={current_dealer_highest_bet ?? 0}
      />
    </View>
  )
}

export default LikeItemExpanded
